import React, { useState } from "react";
import TeamService from "services/TeamService";
import { useExpressionsContext } from "store/contexts/expressionsContext";
import { CSSTransition } from "react-transition-group";
import * as moment from "moment";
import Loader from "components/Loader";
import { useUserContext } from "store/contexts/userContext";
import ReactionDailogue from "../ReactionDailogue";
import userAvatar from "assets/img/user.svg";

function CommentMessage({ post, expression }) {
  const [showReactions, setShowReaction] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateExpression } = useExpressionsContext();
  const { user } = useUserContext();
  const [dialogState, setDialogState] = useState(false);
  const moreReaction = {
    display: "flex",
    justifyContent: "center",
    color: "rgb(0 0 0 / 75%)",
    fontWeight: "400",
    padding: "5px 10px",
    width: "max-content",
  };

  const showReactionUserList = async (event) => {
    setShowReaction(event.currentTarget);

    if (!expression.reactions) {
      setLoading(true);

      await getReactionDetails();
    }
  };

  const getReactionDetails = async () => {
    try {
      const response = await TeamService.getCommentBuzzlist(
        post?.team_id,
        post?.id,
        expression?.id
      );

      updateExpression({
        ...expression,
        reactions: response?.data?.data,
      });
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const hideReactionUserList = () => {
    setShowReaction(null);
  };

  const showDailogue = () => {
    if (!loading && expression.reactions.length !== 0) {
      setShowReaction(null);
      setDialogState(true);
    }
  };

  return (
    <>
      <div
        onMouseEnter={showReactionUserList}
        onMouseLeave={hideReactionUserList}
        onClick={showDailogue}
        className="comment-footer-message"
      >
        {expression?.buzzes_count > 0 && (
          <img
            src={
              (expression?.buzz_type_id === null
                ? expression?.recent_buzz_activity_user?.avatar
                : user?.avatar) ?? userAvatar
            }
            alt={`${expression?.recent_buzz_activity_user?.full_name}`}
            className="buzzUserImage"
          />
        )}
        {Boolean(expression?.buzzes_count) &&
          `${expression?.buzzes_count} reacted`}
        {Boolean(expression?.buzzes_count) &&
          Boolean(expression?.replies_count) &&
          ", "}
        {Boolean(expression?.replies_count) &&
          `${expression?.replies_count} ${
            expression?.replies_count > 1 ? "replies" : "reply"
          }`}
        <CSSTransition
          in={Boolean(showReactions)}
          timeout={300}
          unmountOnExit
          classNames="dropdown-element"
        >
          <div className="reactionListContent reactionsCommentContent">
            <div className="reactionListContainer">
              {loading && <Loader width={40} height={40} />}
              <div>
                {expression?.reactions &&
                  expression?.reactions?.slice(0, 5).map((response, index) => (
                    <ul key={index} className="displayReactionList">
                      <li key={response.id} className="displayReactionList">
                        <p className="muiListItem">
                          <span className="displayReactionName">
                            <span>
                              {response?.user?.id === user?.id
                                ? "You Reacted At "
                                : response?.user?.full_name}
                            </span>
                            <span className="displayDate">
                              {moment(response?.user?.responded_at).format(
                                "MMM DD, YYYY"
                              )}
                            </span>
                          </span>
                        </p>
                      </li>
                    </ul>
                  ))}
                {expression?.buzzes_count > 5 && (
                  <div style={moreReaction}>
                    <span>and {expression?.buzzes_count} more</span>
                  </div>
                )}
              </div>
              {expression.reactions &&
                expression.reactions.length === 0 &&
                !loading && <div style={moreReaction}>No Reaction</div>}
            </div>
          </div>
        </CSSTransition>
      </div>
      {expression?.reactions?.length !== 0 && !loading && (
        <ReactionDailogue
          loading={loading}
          data={expression}
          dialogState={dialogState}
          setDialogState={setDialogState}
        />
      )}
    </>
  );
}

export default CommentMessage;
